export const initConfig = {
    scrollMonitor: false,
    singlePlayerMode: true,
    autoPlayVisibilityThreshold: 0.2
};

export const omnitureConfig = {
    omniture: {
        enabled: true,
        siteTraffic: 'mlb',
        section: 'Gameday',
        bandwagonPlayerEvents: {
            MEDIA_START: 'play',
            MEDIA_COMPLETE: 'ended',
            PLAYBACK_PERCENT_25: 'playbackPercent25',
            PLAYBACK_PERCENT_50: 'playbackPercent50',
            PLAYBACK_PERCENT_75: 'playbackPercent75'
        }
    }
};

export const advertisingConfig = {
    videocore: {
        advertising: {
            dfp: {
                name: 'GD5Plugin',
                enabled: true,
                isDFPSite: true,
                url: 'https://pubads.g.doubleclick.net/gampad/ads',
                adEngEnabled: false,
                output: 'vmap',
                cmsid: 2493822,
                vid: '{id}',
                ad_rule: 1,
                ciu_szs: '300x250',
                gdfp_req: 1,
                env: 'vp',
                unviewed_position_start: 1,
                sz: '640x480',
                npa: 1,
                iu: '/2605/mlb.video/xgameday/desktop',
                pp: 'mlb_csai_vod_desktop'
            }
        },
        tracking: {
            conviva: {
                enabled: true,
                env: 'prod',
                sdk: {
                    core: {
                        dev: 'https://dev.mlbstatic.com/video/libs/conviva/jssdk/4.1.2/conviva-core-sdk.debug.js',
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/jssdk/4.1.2/conviva-core-sdk.debug.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/jssdk/4.1.2/conviva-core-sdk.debug.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/jssdk/4.1.2/conviva-core-sdk.debug.js'
                    },
                    html5Impl: {
                        dev: 'https://dev.mlbstatic.com/video/libs/conviva/html5-impl/4.0.5/conviva-html5native-impl.js',
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/html5-impl/4.0.5/conviva-html5native-impl.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/html5-impl/4.0.5/conviva-html5native-impl.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/html5-impl/4.0.5/conviva-html5native-impl.js'
                    },
                    ima: {
                        dev: 'https://dev.mlbstatic.com/video/libs/conviva/ima/4.0.3/conviva-googleima-module.js',
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/ima/4.0.3/conviva-googleima-module.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/ima/4.0.3/conviva-googleima-module.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/ima/4.0.3/conviva-googleima-module.js'
                    },
                    dai: {
                        dev: 'https://dev.mlbstatic.com/video/libs/conviva/dai/4.0.1/conviva-googledai-module.js',
                        qa: 'https://qa.mlbstatic.com/video/libs/conviva/dai/4.0.1/conviva-googledai-module.js',
                        beta: 'https://beta.mlbstatic.com/video/libs/conviva/dai/4.0.1/conviva-googledai-module.js',
                        prod: 'https://www.mlbstatic.com/video/libs/conviva/dai/4.0.1/conviva-googledai-module.js'
                    }
                },
                customerKey: '268a2000018370f5f35b29272d1942aa2ff7b6a9',
                testCustomerKey: '4af73f0b82a20ad9b5bda00c2d1195d766d35e4c',
                testNetwork: true,
                testGatewayUrl: 'https://mlbtv-test.testonly.conviva.com'
            }
        }
    }
};

export const mediaConfig = {
    global: {
        preferredPlaybackScenarios: [
            'hlsCloud',
            'HTTP_CLOUD_WIRED_WEB',
            'HTTP_CLOUD_TABLET',
            'HTTP_CLOUD_MOBILE',
            'mp4Avc',
            'FLASH_1800K_960X540_HD',
            'FLASH_1800K_960X540',
            'FLASH_1200K_640X360',
            'FLASH_1000K_640X360'
        ]
    },
    playerTypeConfig: {
        hlsjsPlayerConfig: {
            autoStartLoad: false
        }
    }
};

export const controlsConfig = {
    quickRewindButton: {
        enabled: false
    },
    quickForwardButton: {
        enabled: false
    }
};

export default {
    initConfig,
    mediaConfig,
    controlsConfig
};
